// The site's languages, as the page editor uses them.
//
// The mirror of ./sections, and one file for the same reason: what a picker
// OFFERS has to agree with what the thing behind it accepts. A page's `locale`
// is `$ref: /Site/Locale/Code` — the same document a site's `locales` entries
// are built from — and `PageEntityMutations.translate` refuses a code the site
// does not declare with `page.translate.locale.undeclared`. So the list a
// picker shows is the site's own `locales`, and nothing else can be offered.

// Options for a locale picker, in the shape the `select` widget wants.
//
// A function rather than an array because form-schema calls `options` with the
// resolved property. Callers memoise the result on `locales`: the returned
// closure is what the form's `config` is built from, and a fresh identity
// there rebuilds the widget tree beneath the form, detaching the control being
// typed into (P139).
//
// THE EMPTY OPTION IS NOT A PLACEHOLDER. `locale` defaults to "" and empty is
// a valid stored value: `localeOf` in @common/render/page resolves a page with
// none through the site's `defaultLocale`, and every page written before the
// field says exactly that. A picker with no way back to it would make the
// field one-way — the first pick would be permanent — so it is an option like
// any other rather than the disabled `Select…` the widget synthesises for a
// value it does not recognise.
export const localeOptions = (locales) => () => [
  { value: "", label: "Site default" },
  ...locales.map(({ code, label }) => ({
    value: code,
    // The label is optional on a site's locale row and the code is not, so the
    // code leads: it is the value being stored, it is what `<html lang>` will
    // say, and a row labelled only "Español" would not tell an author which of
    // `es` and `es-MX` they had just chosen.
    label: label ? `${code} — ${label}` : code,
  })),
];

// Options for the picker on the TRANSLATE screen, which is the same list minus
// the one option above that does not belong on it.
//
// No "Site default" row here, and that is the whole difference. On the Page tab
// an empty `locale` is a page that has not said which language it is in —
// storable, and the default. As the TARGET of a translation it is not a
// language at all: `/Public/Page/Translate` makes `locale` required, and
// `PageEntityMutations.translate` refuses the empty string twice over — as a
// code the site does not declare, and as the code the source page already
// resolves to.
//
// The caller decides which codes reach this. Two are excluded before it is
// called and for reasons the screen can see and this file cannot: the source
// page's own language, and any language the translation group already has a
// page in. Both are refusals in the model; offering them would be a picker
// whose entries are known in advance to fail.
export const translateLocaleOptions = (locales) => () =>
  locales.map(({ code, label }) => ({
    value: code,
    label: label ? `${code} — ${label}` : code,
  }));
